module.exports = __webpack_public_path__ + "img/Logo04.0178bc77.png";